// extracted by mini-css-extract-plugin
export default {"progress":"progress_progress__YzLku","progressElement":"progress_progressElement__IeeI0","value":"progress_value__jfDS-"};